import React, { useState } from "react";
import '../../CustomAssets/Css/Components/Accordion.css';
import { TiPlusOutline } from "react-icons/ti";

const AccordionItem = ({ title, content, id }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="accordion-item">
      <h5 className="accordion-header">
        <button
          className={`accordion-button ${isOpen ? "" : "collapsed"}`}
          type="button"
          onClick={toggleAccordion}
          aria-expanded={isOpen ? "true" : "false"}
          aria-controls={id}
        >
          {title}
        </button>
      </h5>
      <div
        id={id}
        className={`accordion-collapse ${isOpen ? "show" : ""}`}
      >
        <div className="accordion-body">
          <p className="mb-0">{content}</p>
        </div>
      </div>
    </div>
  );
};

const Accordion = () => {
 
  const faqData = [
    {
      id: "faq-accordion-4-faq-673c74b95b955-1",
      title: "How can I apply for a partnership with your platform?",
      content:
        "To apply for a partnership, simply choose a plan that suits your needs. After selecting a plan, submit your application, and one of our team members will get in touch with you to guide you through the next steps.",
    },
    {
      id: "faq-accordion-4-faq-673c74b95b955-2",
      title: "What documents are required for partnership registration?",
      content:
        "You’ll need to provide a valid Aadhaar card, PAN card, and a recent passport-size photo. Additional documents may be required based on the plan and services you choose.",
    },
    {
      id: "faq-accordion-4-faq-673c74b95b955-3",
      title: "How long does it take to activate my partner panel?",
      content:
        "Once your documents are verified and payment is confirmed, your partner panel will be activated within 24 to 48 working hours.",
    },
    {
      id: "faq-accordion-4-faq-673c74b95b955-4",
      title: "Is there any training or support available after registration?",
      content:
        "Yes, we provide onboarding support, training materials, and ongoing RM (Relationship Manager) assistance to ensure you make the most of our platform and services.",
    },
    {
      id: "faq-accordion-4-faq-673c74b95b955-5",
      title: "Can I upgrade or change my plan later?",
      content:
        "Absolutely! You can upgrade or switch your plan anytime. Just contact your RM or our support team, and we’ll help you transition smoothly.",
    },
    {
      id: "faq-accordion-4-faq-673c74b95b955-6",
      title: "Why choose us?",
      content:
        "We provide all legal documentation including company stamp paper, legal agreement, ID cards, banners, and other essential materials to help you start your financial journey professionally and confidently.",
    },
  ];

  

  return (
    <div className="accordion" id="faq-673c74b95b955">
      {faqData.map((item, index) => (
        <AccordionItem
          key={index}
          id={item.id}
          title={item.title}
          content={item.content}
        />
      ))}
    </div>
  );
};

export default Accordion;
